import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-attendees-banner',
  templateUrl: 'attendees-banner.component.html'
})
export class AttendeesBannerComponent implements OnInit{
  constructor() {}

  attendeeCount = 0;

  ngOnInit(): void {
    // let's grab count via API, do we need to log "what they're saying?"
  }
}
